/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type MarketplaceProductFieldsView = {
    /**
     * Resolved marketplace code: amazon/otto/kaufland/metro for the tuned channels, or a slug of the channel name for any other marketplace.
     */
    marketplace: string;
    /**
     * Selected marketplace category (SCX kCategory)
     */
    kCategory?: number | null;
    cCategoryId?: string | null;
    categoryName?: string | null;
    listingAllowed?: boolean;
    /**
     * ok | category_not_selected | category_attributes_missing
     */
    status: MarketplaceProductFieldsView.status;
    /**
     * Whether the category-attribute metadata is fresh (within the sync TTL)
     */
    syncFresh?: boolean;
    syncReason?: string | null;
    /**
     * Full attribute schema (required + recommended + optional): the selected category's attributes (`level: "category"`) PLUS the marketplace-wide Verkaufskanäle attributes of the channel itself (`level: "channel"`). Values/versions are NOT here — read them from languageVersions[lang] by `apiName`.
     */
    attributes?: Array<{
        cAttributeId?: string;
        /**
         * Marketplace field key: the `mpAttr_` prefix + the real SCX cAttributeId (treat as an opaque token, do not parse). Send this as the `fields` key to `POST /content-master/save-draft` to edit the value. Current value + full version history live in `ContentMasterProductView.languageVersions[lang].draft[apiName]` / `.versions[apiName]` — the SAME place as core/wawi fields (one source of truth).
         */
        apiName?: string;
        displayName?: string;
        type?: string;
        /**
         * Attribute origin: `category` = attribute of the selected marketplace category (SCX.tCategoryAttribute); `channel` = marketplace-wide Verkaufskanäle attribute of the sales channel itself (SCX.tChannelAttribute), the same for every category. Use it to group the fields in the UI.
         */
        level?: 'category' | 'channel';
        /**
         * The marketplace's own filling recommendation for this attribute (the tooltip behind the info icon in Wawi, SCX cDescription). Full untruncated text; null when the marketplace ships none. Shown to the user AND passed to the AI as a filling hint during generation.
         */
        description?: string | null;
        required?: boolean;
        recommended?: boolean;
        multiple?: boolean;
        /**
         * Enum value strings (empty for free-text). For enum attributes the value MUST be one of these.
         */
        allowedValues?: Array<string>;
        /**
         * Enum value + localized label pairs (empty for free-text). Render the label, submit/store the value.
         */
        allowedOptions?: Array<{
            value?: string;
            label?: string;
        }>;
        /**
         * Informational only: whether this attribute already has a generated draft (was part of a generation run). It does NOT gate editing — EVERY attribute in this list is editable via save-draft and writable on apply (validated live against the article's SCX category), EXCEPT `type: "label"` display-only attributes. No prior generation is required.
         */
        generated?: boolean;
        /**
         * Whether Wawi already holds a value for this attribute on the article
         */
        wawiFilled?: boolean;
        /**
         * LIVE value currently stored in Wawi (SCX.tArtikelVerkaufskanalFeldWert) for this attribute on the article, read at request time; null when Wawi holds no value. Unlike the `isCurrent` version in languageVersions (what was last applied through this app), this reflects the Wawi database right now — including changes made directly in Wawi.
         */
        currentValue?: string | null;
        /**
         * DEFAULT value pre-filled in Wawi for the whole channel or the selected category ("Verkaufskanalfelder zuordnen"). NOT merged into currentValue — offer the user to apply it (e.g. a button "use Wawi defaults"; applying = save-draft with this text, then apply). Multi-value defaults are newline-joined. Null when Wawi has no default for the attribute.
         */
        defaultValue?: string | null;
        /**
         * Where the defaultValue comes from: `category` = category-level default (more specific, overrides channel), `channel` = channel-wide default. Null when defaultValue is null.
         */
        defaultSource?: 'category' | 'channel' | null;
        /**
         * True when the defaultValue is a Wawi DotLiquid TEMPLATE (e.g. `{{ Vorgang.Merkmale... }}`) — a dynamic reference to article data that Wawi resolves when transmitting the listing. Do NOT offer to apply such defaults as literal text (and do not render the raw template as if it were a value): show them as "dynamic Wawi reference" and leave the attribute untouched — Wawi fills it by itself.
         */
        defaultIsPlaceholder?: boolean;
        /**
         * True for enum attributes whose allowed-value list is missing in Wawi: a generated value for such a field is the AI's best GUESS (free text, not validated against a list) — show a warning next to the field when displaying its value.
         */
        assumedValue?: boolean;
    }>;
    /**
     * Disjoint attribute-group counts over the FULL schema (category + channel-level attributes): `required`, `recommended` (recommended-only, not also required), `other` (neither) — the three sum to the total attribute count. Present in the product LIST too (where `attributes[]` is not loaded). Null when no category is selected or the schema is unavailable.
     */
    attributeCounts?: {
        required?: number;
        recommended?: number;
        other?: number;
    } | null;
    /**
     * Composed Otto Angebotstitel preview (brand/category + Artikelname + Set-Typ/Set-Info/Besondere Merkmale). Only set for Otto channels; null otherwise. Otto builds the real title itself — this is a preview.
     */
    titlePreview?: string | null;
    /**
     * Otto content rule findings on the current Wawi values (lengths, empty-Kurzbeschreibung, duplicate info across title components). Only populated for Otto channels.
     */
    warnings?: Array<{
        field?: string;
        code?: string;
        severity?: 'warning' | 'error';
        message?: string;
    }>;
};
export namespace MarketplaceProductFieldsView {
    /**
     * ok | category_not_selected | category_attributes_missing
     */
    export enum status {
        OK = 'ok',
        CATEGORY_NOT_SELECTED = 'category_not_selected',
        CATEGORY_ATTRIBUTES_MISSING = 'category_attributes_missing',
    }
}

